import Marionette from "backbone.marionette";

export default Backbone.Model.extend({
    urlRoot: function() {
        return "api/login/index.php";
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/models/selfModel.js
// module id = 23
// module chunks = 0